import React, { useEffect, useState } from 'react';
import { searchBookings } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { getStatusColor, getStatusLabel } from '../../../helpers/status';

function Bookings() {
  const [paginationOptions] = useState({
    page: 1,
    limit: 5,
    sort_field: 'updated_at',
    sort_value: 'desc',
    status: 'NEW',
    booking_code: '',
    fullname: '',
    booked_for_date: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: paginationOptions.status,
        booking_code: paginationOptions.booking_code,
        fullname: paginationOptions.fullname,
        ...(paginationOptions.booked_for_date && {
          booked_for_date: paginationOptions.booked_for_date
        })
      }).toString();
      const response = await searchBookings(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };
  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Kode Booking</th>
            <th style={{ whiteSpace: 'nowrap', fontSize: 14 }}>Jumlah Tamu</th>
            <th className="text-left" style={{ whiteSpace: 'nowrap', fontSize: 14 }}>
              Tanggal Pemesanan
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="8">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center text-light-1" colSpan="8">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="8">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {row.booking_code}
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }}>
                {row.guests.filter((item) => item.type === 'LOCAL').length} Lokal{' '}
                {row.guests.filter((item) => item.type === 'FOREIGN').length} Wisman
              </td>
              <td style={{ whiteSpace: 'nowrap', fontSize: 14 }} className="text-left">
                {format(new Date(row.booked_on_date), 'dd/MM/yyyy')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Bookings;
